import React from "react";
import "./RareExclusive.css";

const products = [
  {
    category: "PAITHANI",
    title: "Parrot Green & Crimson Red Pure Silk Paithani Saree",
    image: "/assets/exclusive/exclusive1.jpg",
    price: "₹26,500",
  },
  {
    category: "PAITHANI",
    title: "Red Handloom Pure Silk Paithani Saree",
    image: "/assets/exclusive/exclusive2.webp",
    price: "₹73,999",
  },
];

const RareExclusive = () => {
  const handleEnquire = (productTitle) => {
    const phoneNumber = "917720089312"; 
    const message = encodeURIComponent(
      `Hello! I am interested in inquiring about: ${productTitle}`
    );
    window.open(`https://wa.me/${phoneNumber}?text=${message}`, "_blank");
  };

  return (
    <section className="exclusive">
      <div className="container">
        <div className="exclusive-heading">
          <span>BY ENQUIRY</span>
          <h2>Rare & Exclusive</h2>
        </div>

        <div className="exclusive-grid">
          {products.map((item, index) => (
            <div className="exclusive-card" key={index}>
              <div className="exclusive-image">
                <img
                  src={item.image}
                  alt={item.title}
                  loading="lazy"
                  width="600"
                  height="800"
                />

                <button onClick={() => handleEnquire(item.title)}>
                  ENQUIRE
                </button>
              </div>

              <div className="exclusive-content">
                <span>{item.category}</span>
                <h3>{item.title}</h3>
                <p className="exclusive-price">{item.price}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default RareExclusive;